/* Grabatee QR hand-off v1.1 (2026-08-25)
   ─────────────────────────────────────────────────────────────────────────────
   Loaded by the six sticker-type section wrappers AFTER sticker-customizer.js.
   Inert unless sessionStorage has a design from the QR sticker studio
   (/pages/qr-code-stickers). When it does:

     1. Preselects the Size the customer chose (clicks the matching size button).
     2. Feeds the 300 DPI design PNG into the customizer's own file input via
        DataTransfer — the same mechanism the customizer uses to feed
        Uploadery — so contour, DPI check, preview, approval, Uploadery, and
        cart all run the existing, unmodified production path.
     3. Adds "QR Type" / "QR Content" / "QR Source" line-item properties to the
        sticker line at /cart/add.js time (fetch wrapper, active only on this page while a
        hand-off is live). Properties are added here rather than as hidden
        property inputs because the customizer counts property inputs to know
        when Uploadery has finished — extra inputs would make it resolve early.

   v1.1: "QR Source" carries the customer's raw studio inputs (type + fields,
   read from the studio's own sessionStorage state) so a lost or resized
   reprint can be regenerated exactly. Wi-Fi passwords are never stored — the
   studio strips them before saving state, and the property says so.

   sticker-customizer.js is NOT modified. If the customizer ever stops using
   window.fetch for /cart/add.js, step 3 silently no-ops (the sticker still
   orders correctly; only the QR properties would be missing).
   ────────────────────────────────────────────────────────────────────────────── */
(function () {
  "use strict";
  var KEY = "grabQrHandoff", MAX_AGE_MS = 6 * 60 * 60 * 1000;
  var raw = null;
  try { raw = window.sessionStorage.getItem(KEY); } catch (e) { return; }
  if (!raw) return;
  var data = null;
  try { data = JSON.parse(raw); } catch (e) { data = null; }
  var root = document.getElementById("stickerCustomizer");
  if (!data || !data.dataURL || !root) return;
  var lockedType = root.getAttribute("data-locked-type");
  /* Only consume on the matching product; otherwise leave it for the right page. */
  if (lockedType && data.type && lockedType !== data.type) return;
  if (data.created && Date.now() - data.created > MAX_AGE_MS) { try { sessionStorage.removeItem(KEY); } catch (e) {} return; }

  var meta = { qrType: data.qrType || "", qrSummary: data.qrSummary || "", verified: !!data.verified, dpi: data.dpi || 300 };

  /* Recoverable source: the studio keeps its inputs (minus any password) in
     sessionStorage as "grabQrStudio". Capture them now so the order carries
     what is needed to rebuild the same code later. */
  var source = "";
  try {
    var st = JSON.parse(window.sessionStorage.getItem("grabQrStudio") || "null");
    if (st && st.qrType && st.fields) {
      var f = {};
      Object.keys(st.fields).forEach(function (k) {
        if (k === "password") return;
        var v = st.fields[k];
        if (v === "" || v == null || v === false) return;
        f[k] = v;
      });
      source = st.qrType + " " + JSON.stringify(f);
      if (st.qrType === "wifi") source += " (password not retained — customer rebuilds in the QR studio for reprints)";
      if (source.length > 1500) source = source.slice(0, 1497) + "...";
    }
  } catch (e) { source = ""; }

  function dataURLtoFile(dataURL, name) {
    var parts = dataURL.split(","), mime = (parts[0].match(/data:([^;]+)/) || [0, "image/png"])[1];
    var bin = atob(parts[1]), len = bin.length, bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) bytes[i] = bin.charCodeAt(i);
    return new File([bytes], name, { type: mime });
  }

  function banner(text) {
    var zone = document.getElementById("sc-upload-zone"), card = zone ? zone.closest(".sc-card") : null;
    if (!card || document.getElementById("sc-qr-banner")) return;
    var el = document.createElement("div");
    el.id = "sc-qr-banner"; el.setAttribute("role", "status");
    el.style.cssText = "display:flex;gap:10px;align-items:flex-start;font-size:12.5px;line-height:1.5;color:#0B6B51;background:#eef8f3;border:1px solid #bfe6d2;border-radius:10px;padding:10px 12px;margin-bottom:10px";
    el.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true" style="flex-shrink:0;margin-top:1px"><path d="M20 6 9 17l-5-5"/></svg><span></span>';
    el.querySelector("span").textContent = text;
    card.insertBefore(el, card.firstChild);
  }

  function apply() {
    var fileInput = document.getElementById("sc-file-input");
    var sizeBtn = data.sizeValue ? document.querySelector('#sc-size-list .sc-size-btn[data-size="' + data.sizeValue.replace(/"/g, '\\"') + '"]') : null;
    /* Size buttons are built by the customizer's init — wait for them. */
    if (!fileInput || !document.querySelector("#sc-size-list .sc-size-btn")) return false;
    if (sizeBtn && !sizeBtn.classList.contains("active")) sizeBtn.click();
    try {
      var dt = new DataTransfer();
      dt.items.add(dataURLtoFile(data.dataURL, data.fileName || "qr-sticker.png"));
      fileInput.files = dt.files;
      fileInput.dispatchEvent(new Event("change", { bubbles: true }));
    } catch (e) {
      console.warn("QR hand-off: could not load design", e);
      return false;
    }
    try { sessionStorage.removeItem(KEY); } catch (e) {}
    banner("Your QR sticker design is loaded" + (meta.qrType ? " (" + meta.qrType + ")" : "") + ". Pick a quantity and finish below, then approve the proof. To change the code itself, go back to the QR studio.");
    installCartHook();
    return true;
  }

  function installCartHook() {
    if (!window.fetch || window.__grabQrHooked) return;
    window.__grabQrHooked = true;
    var orig = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === "string" ? input : (input && input.url) || "";
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof init.body === "string" && /^\s*\{/.test(init.body)) {
          var body = JSON.parse(init.body);
          var items = Array.isArray(body.items) ? body.items : null;
          if (items && items.length) {
            var line = items[0]; line.properties = line.properties || {};
            line.properties["QR Type"] = meta.qrType || "Static QR";
            line.properties["QR Content"] = meta.qrSummary || "See artwork";
            line.properties["QR Design"] = "Built in Grabatee QR studio at " + meta.dpi + " DPI" + (meta.verified ? "; decoded in customer browser" : "");
            if (source) line.properties["QR Source"] = source;
            init = Object.assign({}, init, { body: JSON.stringify(body) });
          }
        }
      } catch (e) { /* never block the cart */ }
      return orig.call(this, input, init);
    };
  }

  /* The customizer inits on DOMContentLoaded (deferred scripts run before it
     fires), so wait for it, then let the customizer's own init finish. */
  function start() {
    var tries = 0;
    (function tick() {
      if (apply()) return;
      if (++tries < 40) setTimeout(tick, 100);
    })();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { setTimeout(start, 0); });
  else setTimeout(start, 0);
})();
